import { render, staticRenderFns } from "./AppVersionList.vue?vue&type=template&id=d761e084"
import script from "./AppVersionList.vue?vue&type=script&lang=js"
export * from "./AppVersionList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports